import React, { useRef, useState } from "react";
import { Button, Input, NavDivider, Navigation, TOAST } from "retro/index";
import { post } from "App/Network/Axios";
// import HotelSearchInput as SearchCities from "App/Components/Inputs/HotelSearchInput/HotelSearchInput";
import SearchCities from "App/Components/Inputs/HotelSearchInput/HotelSearchInput";

export default function UpdateCityAndMoveToReseller() {
  const TRANSID = useRef();
  const CRN = useRef();
  const GST = useRef();
  const SVC = useRef();
  const REMARKS = useRef();
  const [loading, setLoading] = useState(false);
  const [Citi, setCiti] = useState({ country: "india" });
  return (
    <div>
      <Navigation backUrl={"back"} title="Update City and Move to Reseller" />
      <NavDivider />
      <Input
        ref={TRANSID}
        type="text"
        label="Transaction Id"
        placeholder="Transaction Id"
      />
      <Input
        ref={GST}
        type="text"
        label="New Gst Number"
        placeholder="New Gst Number"
      />
      <Input
        ref={CRN}
        type="text"
        defaultValue="CRFN"
        label="Credit Note Prefix"
        placeholder="Credit Note Prefix for Old Service Charge"
      />
      <Input
        ref={SVC}
        type="text"
        defaultValue="SNC"
        label="Service Prefix"
        placeholder="New Service Prefix"
        className='mb1'
      />
      
      {/* search city */}
      <label style={{marginTop: '16px'}}>Select City</label>
      <SearchCities
        recentCities={true}
        hide={true}
        className="mt1"
        api="/meta/cities/search"
        onSelect={(city) => {
          setCiti(city);
        }}
        selected={Citi}
        placeholder={"Search City"}
        renderResult={(item) => (
          <div>
            <p>
              {item?.name}
              {item.country === "India" ? `, ${item?.state}` : ""},{" "}
              {item?.country}
            </p>
          </div>
        )}
      />
      {/* updates state after selecting city */}
      <Input
        label="Hotel State"
        className="mt2"
        defaultValue={Citi.state}
        disabled={true}
        placeholder="Select State"
      />
      <Input ref={REMARKS} type="text" label="Remarks" placeholder="Remarks" />
      <Button
        onClick={() => {
          let transId = TRANSID.current.value;
          let remarks = REMARKS.current.value;
          let crn = CRN.current.value;
          let svc = SVC.current.value;
          let gstin = GST.current.value;
          let city = Citi.name;
          let state = Citi.state;
          if (!transId) {
            TOAST.error("Enter a valid trans id");
            return;
          }
          if (!svc) {
            TOAST.error("Enter a valid service charges");
            return;
          }
          if (!crn) {
            TOAST.error("Enter a valid credit number");
            return;
          }
          if (!gstin) {
            TOAST.error("Enter a valid gstin");
            return;
          }
          if (!city) {
            TOAST.error("Enter city");
            return;
          }
          if (!state || state === "NONE") {
            TOAST.error("Enter state");
            return;
          }
          setLoading(true);
          let data = {
            remarks,
            gstin,
            svc,
            crn,
            city,
            state:state?.trim().replaceAll(" ","").toUpperCase(),
          }
          post(
            // `/meta/${transId}/hotel/agency/reseller/switch`,
            `/meta/${transId}/hotel/agency/reseller/switch/city`,
            data,
            (err, res) => {

              setLoading(false);
              if (res) {
                console.log("response is.... ", res);
                TOAST.success("Regeneration done successfully");
                TRANSID.current.value = "";
                REMARKS.current.value = "";
              } else {
                TOAST.handleError(err);
              }
            }
          );
        }}
        className="btn-black btn-primary"
        margin="pd2 mt4"
        loading={loading}
      >
        Regenerate
      </Button>
    </div>
  );
}
